module.exports = __webpack_public_path__ + "static/media/tpn-events.847c0989.png";